// extracted by mini-css-extract-plugin
export default {"container":"Trend_container__9JG-M","positive":"Trend_positive__GGcVo","negative":"Trend_negative__rPeAX","neutral":"Trend_neutral__VAeoA"};